var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.statusType === 'error' ? 'alert-error inline' : 'form-actions-message'},[_c('translation',{attrs:{"text":_vm.lang.get(_vm.status)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }